import {Cloud} from './cloud';
import {Text} from './text';

export class Card {
  id?: number;
  title: string[] = [];
  text: string[] = [];
  img: string= '';
  style: string = '';
  button?: boolean = false;
  flex?: string;
  cloud?: Cloud;
  link?: string | null;
  place?: number;
  cssStyle?: string;
  rating?: number;
  tag?: string;
  tagRu?: string;
  orientation?: 'horizontal' | 'vertical';
  position?: 'horizontal' | 'vertical';
  anotherButton?: boolean;
  anotherButtonText?: Text[];
  feedValue?: Text[];
  anotherHotelText?: Text[];
  anotherHotelButton?: boolean;
  backgroundPosition?: string;

  constructor(data: Card) {
    this.id = data.id;
    this.title = data.title ?? [];
    this.text = data.text ?? [];
    this.img = data.img ?? '';
    this.style = data.style ?? '';
    this.button = data.button ?? false;
    this.flex = data.flex ?? '';
    this.cloud = data.cloud;
    this.link = data.link ?? '';
    this.place = data.place;
    this.cssStyle = data.cssStyle;
    this.rating = data.rating;
    this.tag = data.tag;
    this.tagRu = data.tagRu;
    this.orientation = data.orientation;
    this.position = data.position;
    this.anotherButton = data.anotherButton;
    this.anotherButtonText = data.anotherButtonText;
    this.feedValue = data.feedValue;
    this.anotherHotelText = data.anotherHotelText;
    this.anotherHotelButton = data.anotherHotelButton;
    this.backgroundPosition = data.backgroundPosition;
  }
}

export const CardsArray: Card[] = [
  { //1
    id: 0,
    title: ['Командировки', 'Business Trips'],
    text: ['Организация деловых поездок для встреч, переговоров, конференций и выставок', 'Organization of business trips for meetings, negotiations, conferences and exhibitions'],
    img: '/app/assets/images/sky.jpeg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Корпоративным клиентам', 'Corporate Services']}],
    backgroundPosition: '-350px',
  },
  { //2
    id: 3,
    title: ['Корпоративные мероприятия', 'Corporate Events'],
    text: ['Организация конференций, семинаров, тренингов, выставок и презентаций', 'Organization of conferences, seminars, trainings, exhibitions and presentations'],
    img: '/app/assets/images/party.svg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Корпоративным клиентам', 'Corporate Services']}],
  },
  { //3
    id: 2,
    title: ['Тимбилдинг', 'Team Building'],
    text: ['Организация мероприятий для сплочения команды и улучшения взаимодействия. В программе — спортивные игры, квесты, выездные тренинги и другие активности', 'Organizing events to build a team and improve collaboration. The program includes sports games, quests, field trainings and other activities.'],
    img: '/app/assets/images/team-build.svg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Корпоративным клиентам', 'Corporate Services']}],
  },
  { //4
    id: 4,
    title: ['Образовательные поездки', 'Educational Trips'],
    text: ['Организация путешествий для повышения квалификации, освоения новых навыков и обмена опытом с коллегами из других компаний или стран', 'Travel arrangements for professional development, learning new skills, and sharing experiences with colleagues from other companies or countries'],
    img: '/app/assets/images/writer.svg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Корпоративным клиентам', 'Corporate Services']}],
  },
  { //5
    id: 5,
    title: ['Выездные стратегические сессии', 'Offsite Strategic Sessions'],
    text: ['Организация встреч для руководства компании с целью стратегического планирования и принятия ключевых решений', 'Organization of meetings for the company`s management for the purpose of strategic planning and making key decisions'],
    img: '/app/assets/images/session.svg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Корпоративным клиентам', 'Corporate Services']}],
  },
  { //6
    id: 1,
    title: ['Инсентив-туры', 'Incentive Tours'],
    text: ['Поездки для сотрудников в качестве награды за рабочие достижения. Включают отдых, развлекательные мероприятия и тимбилдинги', 'Trips for employees as a reward for work achievements. These tours may include leisure activities, entertainment events, and team-building exercises'],
    img: '/app/assets/images/paradise.jpeg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Корпоративным клиентам', 'Corporate Services']}],
  },
];


export const CardsArrayVoyages: Card[] = [
  {
    id: 0,
    title: ['Индивидуальные туры', 'Individual Tours'],
    text: [
      'Наслаждайтесь уникальными путешествиями с индивидуальными маршрутами и личным гидом для незабываемых приключений',
      'Enjoy unique, tailor-made journeys with custom itineraries and a personal guide for ultimate adventure'
    ],
    img: '/app/assets/images/desert.jpg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Другое', 'Other']}],
  },
  {
    id: 1,
    title: ['Роскошные путешествия', 'Luxury Travel'],
    text: [
      'Останавливайтесь в лучших отелях и эксклюзивных частных резиденциях в удивительных и уединённых местах',
      'Stay in the finest hotels and exclusive private residences in stunning and secluded locations'
    ],
    img: '/app/assets/images/seaHotel.jpg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Другое', 'Other']}],
  },
  {
    id: 2,
    title: ['Премиальный трансфер', 'Premium Transfer'],
    text: [
      'Частные самолеты, вертолеты и роскошные яхты, адаптированные под ваши потребности',
      'Travel in comfort and privacy with private jets, helicopters, and luxury yachts, tailored to your needs'
    ],
    img: '/app/assets/images/planeCabin.jpg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Другое', 'Other']}],
  },
  {
    id: 3,
    title: ['Частные мероприятия', 'Private Events'],
    text: [
      'Празднуйте важные события в уникальных местах с продуманным сервисом и атмосферой',
      'Celebrate special moments with meticulously organized private events like weddings, birthdays or concerts'
    ],
    img: '/app/assets/images/holidays.jpg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Другое', 'Other']}],
  },
  {
    id: 4,
    title: ['Эксклюзивные впечатления', 'Exclusive Experiences'],
    text: [
      'Погружайтесь в тематические путешествия и приключенческие туры, которые соответствуют вашим уникальным интересам',
      'Indulge in themed travel and adventure tours that cater to your unique interests'
    ],
    img: '/app/assets/images/diving.jpg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Другое', 'Other']}],
  },
  {
    id: 4,
    title: ['Оздоровление и релакся', 'Health & Wellness'],
    text: [
      'Восстанавливайте силы в лучших спа-курортах с индивидуальными программами или получайте первоклассные медицинские услуги по всему миру',
      'Rejuvenate at top spa resorts with personalized programs or receive high-quality medical treatments worldwide'
    ],
    img: '/app/assets/images/relax.jpg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Другое', 'Other']}],
  },
];

export const CardsArrayVoyagesNew: Card[] = [
  { //1
    id: 0,
    title: ['Бронирование отелей', 'Hotel Booking'],
    text: [
      'Основным направлением нашей деятельности является оказание услуг по бронированию отелей по всему миру. Мы работаем напрямую с ведущими отельными сетями и независимыми пятизвёздочными отелями, что позволяет выстраивать долгосрочные партнёрские отношения и предлагать клиентам высокий уровень сервиса и доверия со стороны отелей.',
      'Our core business is providing hotel reservation services worldwide. We work directly with leading hotel chains and independent five-star hotels, which allows us to build long-term partnerships and offer our clients a high level of service and trust from the hotels.'
    ],
    img: '/app/assets/images/newEvents/hotel.jpg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Другое', 'Other']}],
  },
  { //2
    id: 1,
    title: ['Индивидуальные туры', 'Private Tours'],
    text: [
      'Наслаждайтесь уникальными путешествиями с индивидуальными маршрутами и личным гидом для незабываемых приключений',
      'Enjoy unique, tailor-made journeys with custom itineraries and a personal guide for ultimate adventure'
    ],
    img: '/app/assets/images/newEvents/jet.jpg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Другое', 'Other']}],
  },
  { //3
    id: 2,
    title: ['Аренда автомобилей с водителем', 'Chauffeur-Driven Car Services'],
    text: [
      'Аренда автомобиля с водителем — это спокойное и комфортное передвижение без забот. Профессиональный водитель, продуманный маршрут и полное внимание к вашему времени.',
      'Car rental with a driver is a calm and comfortable way to travel without worries. A professional driver, a well-planned route, and complete attention to your time.'
    ],
    img: '/app/assets/images/newEvents/car.jpg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Другое', 'Other']}],
    backgroundPosition: '-275px'
  },
  { //4
    id: 3,
    title: ['Частные мероприятия', 'Private Events'],
    text: [
      'Празднуйте важные события в уникальных местах с продуманным сервисом и атмосферой',
      'Celebrate special moments with meticulously organized private events like weddings, birthdays or concerts'
    ],
    img: '/app/assets/images/holidays.jpg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Другое', 'Other']}],
  },
  { //5
    id: 4,
    title: ['Оздоровительный туризм', 'Wellness Travel'],
    text: [
      'Восстанавливайте силы в лучших спа-курортах с индивидуальными программами или получайте первоклассные медицинские услуги по всему миру',
      'Rejuvenate at top spa resorts with personalized programs or receive high-quality medical treatments worldwide'
    ],
    img: '/app/assets/images/relax.jpg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Другое', 'Other']}],
  },
  { //6
    id: 5,
    title: ['Эксклюзивные впечатления', 'Exclusive Experiences'],
    text: [
      'Погружайтесь в тематические путешествия и приключенческие туры, которые соответствуют вашим уникальным интересам',
      'Indulge in themed travel and adventure tours that cater to your unique interests'
    ],
    img: '/app/assets/images/diving.jpg',
    style: '',
    button: true,
    link: '/feedback',
    anotherButtonText: [{text: ['Связаться', 'Contact us ']}],
    feedValue: [{text: ['Другое', 'Other']}],
  },
];

export const Cards = {
  businessTrips: CardsArray[0],
  incentiveTours: CardsArray[1],
  teamBuilding: CardsArray[2],
  corporateEvents: CardsArray[3],
  educationalTrips: CardsArray[4],
  offsiteStrategicSessions: CardsArray[5],
  fastTrack: CardsArray[6],
  meetGreet: CardsArray[7],
  premiumTransfer: CardsArray[8],
  premiumWaitingRooms: CardsArray[9],
  concierge: CardsArray[10],
  privateLuxury: CardsArray[11],
  individualTours: CardsArray[12],
  luxuryTravel: CardsArray[13],
  premiumTransferAir: CardsArray[14],
  privateEvents: CardsArray[15],
  exclusiveExperiences: CardsArray[16],
  wellnessRelaxation: CardsArray[17],
}


export const CardsArrayHotels: Card[] = [
  {
    id: 0,
    title: ['', ''],
    text: ['Capella Bangkok', 'Capella Bangkok'],
    img: '/app/assets/images/hotel.png',
    style: '',
    button: false,
  },
  {
    id: 1,
    title: ['', ''],
    text: ['Capella Bangkok', 'Capella Bangkok'],
    img: '/app/assets/images/hotels/h1.jpeg',
    style: '',
    button: false,
  },
  {
    id: 2,
    title: ['', ''],
    text: ['Capella Bangkok', 'Capella Bangkok'],
    img: '/app/assets/images/hotels/h2.png',
    style: '',
    button: false,
  },
  {
    id: 3,
    title: ['', ''],
    text: ['Capella Bangkok', 'Capella Bangkok'],
    img: '/app/assets/images/hotels/h3.jpeg',
    style: '',
    button: false,
  },
  {
    id: 4,
    title: ['', ''],
    text: ['Capella Bangkok', 'Capella Bangkok'],
    img: '/app/assets/images/hotels/h4.png',
    style: '',
    button: false,
  },
  {
    id: 5,
    title: ['', ''],
    text: ['Capella Bangkok', 'Capella Bangkok'],
    img: '/app/assets/images/hotels/h5.png',
    style: '',
    button: false,
  },
]

export const CardsArrayTypesTravels: Card[] = [
  {
    id: 0,
    title: ['', ''],
    text: ['Пляж', 'Beach'],
    img: '/app/assets/images/typesTravel/beach1.jpeg',
    style: '',
    button: false,
    link: 'adventures/Beach',
  },
  {
    id: 1,
    title: ['', ''],
    text: ['Лыжи', 'Ski'],
    img: '/app/assets/images/typesTravel/ski.jpeg',
    style: '',
    button: false,
    link: 'adventures/ski',
  },
  {
    id: 2,
    title: ['', ''],
    text: ['Медовый месяц', ' Honeymoon'],
    img: '/app/assets/images/typesTravel/honeymoon.jpeg',
    style: '',
    button: false,
    link: 'adventures/Honeymoon',
  },
  {
    id: 6,
    title: ['', ''],
    text: ['Религиозное', 'Religious'],
    img: '/app/assets/images/typesTravel/Religious.jpeg',
    style: '',
    button: false,
    link: 'adventures/Religious',
  },
  {
    id: 7,
    title: ['', ''],
    text: ['Культурное', 'Cultural'],
    img: '/app/assets/images/typesTravel/Cultural.jpeg',
    style: '',
    button: false,
    link: 'adventures/Cultural',
  },
  {
    id: 8,
    title: ['', ''],
    text: ['Оздоровительное', 'Wellness'],
    img: '/app/assets/images/typesTravel/Wellness.jpeg',
    style: '',
    button: false,
    link: 'adventures/Wellness',
  },
  {
    id: 9,
    title: ['', ''],
    text: ['Осмотр достопримечательностей', 'Sightseeing'],
    img: '/app/assets/images/typesTravel/Sightseeing.jpeg',
    style: '',
    button: false,
    link: 'adventures/Sightseeing',
  },
  {
    id: 10,
    title: ['', ''],
    text: ['Приключения', 'Adventure'],
    img: '/app/assets/images/typesTravel/Adventure.jpeg',
    style: '',
    button: false,
    link: 'adventures/Adventure',
  },
  {
    id: 11,
    title: ['', ''],
    text: ['Гастрономическое', 'Gastronomic'],
    img: '/app/assets/images/typesTravel/Gastronomic.jpeg',
    style: '',
    button: false,
    link: 'adventures/Gastronomic',
  },
  {
    id: 12,
    title: ['', ''],
    text: ['Экотуризм', 'Ecotourism'],
    img: '/app/assets/images/typesTravel/Ecotourism.jpeg',
    style: '',
    button: false,
    link: 'adventures/Ecotourism',
  },
  {
    id: 13,
    title: ['', ''],
    text: ['Ночная жизнь', 'Night life'],
    img: '/app/assets/images/typesTravel/night-life.jpeg',
    style: '',
    button: false,
    link: 'adventures/Night-life',
  },
]

export const CardsArrayTelAviv: Card[] = [
  {
    id: 0,
    title: ['Добро пожаловать', 'Welcome'],
    text: [
      'Начните свое приключение в Тель-Авиве с знакомства с Яффо, древним портовым городом с очаровательными улочками, оживленными рынками и живописной гаванью. Прогуляйтесь по бульвару Ротшильда, оживленной улице, известной своим эклектичным сочетанием ресторанов, бутиков и кафе. Во второй половине дня отдохните на пляжах Тель-Авива, наслаждаясь Средиземным морем и оживленной пляжной атмосферой',
      'Start your adventure in Tel Aviv by exploring Jaffa, an ancient port city with charming alleys, vibrant markets, and a picturesque harbor. Stroll down Rothschild Boulevard, a bustling street known for its eclectic mix of restaurants, boutiques, and cafes. In the afternoon, relax on Tel Aviv Beaches, enjoying the Mediterranean Sea and the lively beach atmosphere'
    ],
    img: '/app/assets/images/cities/jaffa/1.jpeg',
    style: '',
    button: false,
  },
  {
    id: 0,
    title: ['Яффо', 'Jaffa'],
    text: [
      'Яффо представляет себе древнюю крепость Масада, залитую лучами заходящего солнца, которая становится декорацией для оперного фестиваля в Масаде. Впечатляющий пейзаж пустыни и исторические руины создают условия для мощного сочетания музыки и истории. Когда вы сидите под звездами, в ночи эхом разносятся парящие арии и оркестровые композиции, создавая уникальное сочетание культурного и исторического величия. Фестиваль предлагает незабываемые впечатления, когда неподвластная времени красота оперы сочетается с древним великолепием Масады.',
      'Imagine the ancient fortress of Masada, bathed in the glow of the setting sun, as it becomes the backdrop for the Masada Opera Festival. The dramatic desert landscape and historic ruins set the stage for a powerful blend of music and history. As you sit under the stars, the soaring arias and orchestral compositions echo through the night, creating a unique fusion of cultural grandeur and historical majesty. The festival offers an unforgettable sensory experience, where the timeless beauty of the opera meets the ancient splendor of Masada'
    ],
    img: '/app/assets/images/cities/jaffa/1.jpeg',
    style: '',
    button: false,
  },
  {
    id: 1,
    title: ['Бульвар Ротшильда', 'Rothschild Boulevard'],
    text: [
      'Иерусалимский международный кинофестиваль превращает город в центр кинематографа, привлекая любителей кино со всего мира. Проходя по фестивалю, вы погружаетесь в мир разнообразных фильмов — от заставляющих задуматься документальных лент до захватывающих драм и новаторских короткометражек. Атмосфера наполнена волнением и интеллектуальной энергией, поскольку создатели фильмов, критики и зрители участвуют в оживленных дискуссиях. Каждый показ открывает окно в разные культуры и точки зрения, вдохновляя и обогащая вас глобальным повествованием, представленным в одном из самых исторических городов мира',
      'The Jerusalem International Film Festival transforms the city into a cinematic hub, drawing film enthusiasts from around the world. As you navigate through the festival, you’re immersed in a diverse array of films—from thought-provoking documentaries to captivating dramas and innovative shorts. The atmosphere is buzzing with excitement and intellectual energy as filmmakers, critics, and audiences engage in lively discussions. Each screening offers a window into different cultures and perspectives, leaving you inspired and enriched by the global storytelling showcased in one of the world’s most historic cities'
    ],
    img: '/app/assets/images/cities/jaffa/2.png',
    style: '',
    button: false,
  },
];

export const ImageCardsContinentArray: Card[] = [
  {
    id: 0,
    title: [],
    text: [],
    img: '/app/assets/images/slides/continent/beach.png',
    style: '',
    flex: ''
  },
  {
    id: 1,
    title: [],
    text: [],
    img: '/app/assets/images/slides/continent/goat.png',
    style: '',
    flex: 'align-content: flex-end;',
  },
  {
    id: 2,
    title: [],
    text: [],
    img: '/app/assets/images/slides/continent/dinner.png',
    style: '',
    flex: 'align-content: center;',
  },
  {
    id: 3,
    title: [],
    text: [],
    img: '/app/assets/images/slides/continent/mountain.png',
    style: '',
    flex: 'align-content: center;',
  },
  {
    id: 4,
    title: [],
    text: [],
    img: '/app/assets/images/slides/continent/city.png',
    style: '',
    flex: '',
  },
  {
    id: 5,
    title: [],
    text: [],
    img: '/app/assets/images/slides/continent/book.png',
    style: '',
    flex: 'align-content: center;',
  },
  {
    id: 6,
    title: [],
    text: [],
    img: '/app/assets/images/slides/continent/child.png',
    style: '',
    flex: '',
  },
  {
    id: 7,
    title: [],
    text: [],
    img: '/app/assets/images/slides/continent/camel.png',
    style: '',
    flex: '',
  },
  {
    id: 8,
    title: [],
    text: [],
    img: '/app/assets/images/slides/continent/city-tower.png',
    style: '',
    flex: '',
  },
  {
    id: 9,
    title: [],
    text: [],
    img: '/app/assets/images/slides/continent/desert.png',
    style: '',
    flex: 'align-content: flex-end;',
  },
  {
    id: 10,
    title: [],
    text: [],
    img: '/app/assets/images/slides/continent/column.png',
    style: '',
    flex: 'align-content: center;',
  },
  {
    id: 11,
    title: [],
    text: [],
    img: '/app/assets/images/slides/continent/arena.png',
    style: '',
    flex: 'align-content: center;',
  },
]

export const ImageCardsIsraelArray: Card[] = [
  {
    id: 0,
    title: [],
    text: [],
    img: '/app/assets/images/slides/israel/arch.png',
    style: '',
    flex: ''
  },
  {
    id: 1,
    title: [],
    text: [],
    img: '/app/assets/images/slides/israel/beach.png',
    style: '',
    flex: 'align-content: flex-end;',
  },
  {
    id: 2,
    title: [],
    text: [],
    img: '/app/assets/images/slides/israel/ambar.png',
    style: '',
    flex: 'align-content: center;',
  },
  {
    id: 3,
    title: [],
    text: [],
    img: '/app/assets/images/slides/israel/goat.png',
    style: '',
    flex: 'align-content: center;',
  },
  {
    id: 4,
    title: [],
    text: [],
    img: '/app/assets/images/slides/israel/book.png',
    style: '',
    flex: '',
  },
  {
    id: 5,
    title: [],
    text: [],
    img: '/app/assets/images/slides/israel/flag.png',
    style: '',
    flex: 'align-content: center;',
  },
  {
    id: 6,
    title: [],
    text: [],
    img: '/app/assets/images/slides/israel/temple.png',
    style: '',
    flex: '',
  },
  {
    id: 7,
    title: [],
    text: [],
    img: '/app/assets/images/slides/israel/camels.png',
    style: '',
    flex: '',
  },
  {
    id: 8,
    title: [],
    text: [],
    img: '/app/assets/images/slides/israel/man.png',
    style: '',
    flex: '',
  },
  {
    id: 9,
    title: [],
    text: [],
    img: '/app/assets/images/slides/israel/desert.png',
    style: '',
    flex: 'align-content: flex-end;',
  },
  {
    id: 10,
    title: [],
    text: [],
    img: '/app/assets/images/slides/israel/house.png',
    style: '',
    flex: 'align-content: center;',
  },
  {
    id: 11,
    title: [],
    text: [],
    img: '/app/assets/images/slides/israel/reefs.png',
    style: '',
    flex: 'align-content: center;',
  },
]

export const ImageCardsMenuArray: Card[] = [
  {
    id: 0,
    title: [],
    text: [],
    img: '/app/assets/images/slides/menu-cards/bikes.png',
    style: '',
    flex: '',
  },
  {
    id: 1,
    title: [],
    text: [],
    img: '/app/assets/images/slides/menu-cards/tent.png',
    style: '',
    flex: 'align-items: flex-end;',
    cloud: {
      text: [
        {text: [
            'Благодаря многолетнему опыту, глубоким отраслевым знаниям и обширным личным связям в сфере туризма мы обеспечиваем нашим клиентам статус привилегированного гостя по всему миру. Наша миссия — открывать для вас исключительные возможности и дарить незабываемые впечатления.',
            'With many years of experience, deep industry knowledge, and extensive personal connections in the tourism sector, we ensure our clients enjoy privileged guest status worldwide. Our mission is to offer you exceptional opportunities and unforgettable experiences'
          ],},

      ],
      top: 22,
      left: 50,
      title: ['О компании', 'About'],
      minWidthCloud: 278
    }
  },
  {
    id: 2,
    title: [],
    text: [],
    img: '/app/assets/images/slides/menu-cards/beach.png',
    style: '',
    flex: 'align-items: flex-end;',
  },
  {
    id: 3,
    title: [],
    text: [],
    img: '/app/assets/images/slides/menu-cards/surfer.png',
    style: '',
    flex: 'align-items: flex-start;',
  },
  {
    id: 4,
    title: [],
    text: [],
    img: '/app/assets/images/slides/menu-cards/mountain.png',
    style: '',
    flex: '',
  },
  {
    id: 5,
    title: [],
    text: [],
    img: '/app/assets/images/slides/menu-cards/old-man.png',
    style: '',
    flex: 'align-items: flex-center;',
  },
  {
    id: 6,
    title: [],
    text: [],
    img: '/app/assets/images/slides/menu-cards/pilot-girl.png',
    style: '',
    flex: '',
    cloud: {
      text: [
        {text: [
            'Выбирая наши услуги, вы можете быть уверены в высочайшем уровне сервиса, индивидуальном подходе и полной конфиденциальности. Благодаря профессиональным рекомендациям и эксклюзивным предложениям ваш отдых станет по‑настоящему незабываемым и исключительным.',
            'By choosing our service, you can be assured of the highest level of service, a tailored approach, and complete confidentiality. Your vacation will be truly exceptional and memorable, thanks to our expert recommendations and exclusive offers'
          ],},
      ],
      top: 50,
      left: 70,
      title: ['Преимущества', 'Excellence'],
      link: '',
      minWidthCloud: 278
    }
  },
  {
    id: 7,
    title: [],
    text: [],
    img: '/app/assets/images/slides/menu-cards/mountains.png',
    style: '',
    flex: 'align-items: flex-end;',
  },
  {
    id: 8,
    title: [],
    text: [],
    img: '/app/assets/images/slides/menu-cards/sand.png',
    style: '',
    flex: '',
  },
  {
    id: 9,
    title: [],
    text: [],
    img: '/app/assets/images/slides/menu-cards/wedding.png',
    style: '',
    flex: 'align-items: flex-start;',
    cloud: {
      text: [
        {text: ['Business Registration № 77889104', 'Business Registration № 77889104'], transfer: true},
        {text: ['IATA TIDS 96223466', 'IATA TIDS 96223466'], transfer: true},
        {text: [' ', ' '], transfer: true},
        {text: ['Office 4, 10/F Kwan Chart Tower, No. 6 \nTonnochy Rd, Wan Chai, Hong Kong', 'Office 4, 10/F Kwan Chart Tower, No. 6 \nTonnochy Rd, Wan Chai, Hong Kong']},
      ],
      top: 23,
      left: -30,
      paddingTop: 10,
      title: ['2025 © First Class Solutions Limited', '2025 © First Class Solutions Limited'],
      link: '',
      minWidthCloud: 278
    }
  },
  {
    id: 10,
    title: [],
    text: [],
    img: '/app/assets/images/slides/menu-cards/mother.png',
    style: '',
    flex: 'align-items: flex-end;',
  },
  {
    id: 11,
    title: [],
    text: [],
    img: '/app/assets/images/slides/menu-cards/diver.png',
    style: '',
    flex: 'align-items: flex-end;',
  },
]

export const PremiumCareCards: Card[] = [
  {
    id: 0,
    title: ['Business Lounges', 'Business Lounges'],
    text: [
      'Бизнес-залы — идеальное место для отдыха и продуктивной работы. Уютные кресла, бесплатный Wi-Fi, вкусные закуски, журналы и газеты, телевизоры и удобные рабочие зоны создают атмосферу комфорта и уединения',
      'Business lounges are the perfect place to relax and work efficiently. Cozy seating, free Wi-Fi, delicious snacks, magazines and newspapers, TVs, and comfortable workspaces create an atmosphere of comfort and privacy'
    ],
    img: '/app/assets/images/premiumCare/lounges.jpg',
    style: 'filter: grayscale(20%);',
    button: true,
    link: '/feedback'
  },
  {
    id: 1,
    title: ['Premium Lounges', 'Premium Lounges'],
    text: [
      'Премиум-залы предлагают продуманный дизайн и разнообразное меню, часто предоставляя дополнительные услуги, такие как душевые, массажные кресла и спа-процедуры для полного расслабления',
      'Premium lounges feature sophisticated design and a diverse menu, often offering additional services such as showers, massage chairs, and spa treatments for ultimate relaxation'
    ],
    img: '/app/assets/images/premiumCare/lounges1.jpg',
    style: 'filter: grayscale(20%);',
    button: true,
    link: '/feedback'
  },
  {
    id: 2,
    title: ['Quick Security & Passport Control', 'Quick Security & Passport Control'],
    text: [
      'Быстрая проверка безопасности и паспортного контроля — это ваше решение для экономии времени и удобства. Пройдите все формальности без задержек и наслаждайтесь спокойствием на пути к следующему путешествию',
      'Quick security and passport control is your solution for saving time and convenience. Complete all formalities without delays and enjoy peace of mind on your way to your next destination'
    ],
    img: '/app/assets/images/woman.jpeg',
    style: 'filter: grayscale(20%);',
    button: true,
    link: '/feedback'
  },
  {
    id: 3,
    title: ['Airport Escort', 'Airport Escort'],
    text: [
      'Услуга сопровождения в аэропорту — ваш надежный партнер, который сделает ваше путешествие легким и комфортным, обеспечив помощь на каждом шаге, от регистрации до посадки',
      'Airport escort service is your trusted partner, making your journey effortless and comfortable by offering assistance every step of the way, from check-in to boarding'
    ],
    img: '/app/assets/images/premiumCare/car.jpg',
    style: 'filter: grayscale(20%);',
    button: true,
    link: '/feedback'
  },
  {
    id: 4,
    title: ['Premium Transfer', 'Premium Transfer'],
    text: [
      'Премиум-трансфер — это комфорт и стиль на каждом этапе путешествия. Просторные автомобили, персонализированное обслуживание и гарантированное удобство позволяют вам наслаждаться каждой минутой пути',
      'Premium transfer offers comfort and style at every step of your journey. Spacious vehicles, personalized service, and guaranteed convenience ensure you enjoy every minute of the ride'
    ],
    img: '/app/assets/images/premium-car.svg',
    style: 'filter: grayscale(20%);',
    button: true,
    link: '/feedback'
  },
  {
    id: 5,
    title: ['Meet & Greet', 'Meet & Greet'],
    text: [
      'Мы встретим вас и позаботимся о всех организационных моментах, обеспечивая комфорт и безопасность на каждом шаге',
      'Meet & Greet service ensures a smooth start to your journey. Our specialist will greet you, assist through every step, and provide top-notch service'
    ],
    img: '/app/assets/images/red-girls.svg',
    style: 'filter: grayscale(20%);',
    button: true,
    link: '/feedback'
  },
  {
    id: 6,
    title: ['Private Suites', 'Private Suites'],
    text: [
      'Частные люксы — это уединение и роскошь в самом сердце аэропорта. Просторные и элегантные, они обеспечат вам максимальный комфорт и приватность в ожидании рейса',
      'Private suites offer seclusion and luxury at the heart of the airport. Spacious and elegant, they provide the utmost comfort and privacy while waiting for your flight'
    ],
    img: '/app/assets/images/premiumCare/room.jpg',
    style: 'filter: grayscale(20%);',
    button: true,
    link: '/feedback'
  },
  {
    id: 7,
    title: ['Personal Concierge', 'Personal Concierge'],
    text: [
      'Персональный консьерж — ваш надежный помощник, он позаботится о любых потребностях, от организации досуга до решения практических вопросов, обеспечивая комфорт и удобство на протяжении всего путешествия',
      'Personal concierge is your trusted assistant, taking care of every need, from arranging leisure activities to handling practical matters, ensuring comfort and convenience throughout your journey'
    ],
    img: '/app/assets/images/concierge.svg',
    style: 'filter: grayscale(20%);',
    button: true,
    link: '/feedback'
  },
  {
    id: 8,
    title: ['Access to Exclusive Events', 'Access to Exclusive Events'],
    text: [
      'Доступ к эксклюзивным мероприятиям — это возможность стать частью особенных событий, которые недоступны широкой публике. Наслаждайтесь уникальными впечатлениями и создавайте незабываемые воспоминания',
      'Access to exclusive events offers you the opportunity to be part of special occasions that are not available to the general public. Enjoy unique experiences and create unforgettable memories'
    ],
    img: '/app/assets/images/premiumCare/party.jpg',
    style: 'filter: grayscale(20%);',
    button: true,
    link: '/feedback'
  },
]
